import Vue from 'vue'
import Axios from 'axios'
import ActionCable from 'actioncable-vue'
import VueChatScroll from 'vue-chat-scroll'

import '../channels'
import App from '../App.vue'
import router from '../router'

Vue.prototype.$http = Axios

Vue.use(ActionCable, {
  debug: true,
  debugLevel: 'error',
  connectionUrl: '/cable',
  connectImmediately: true
});

Vue.use(VueChatScroll)

import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import 'bulma/css/bulma.min.css'

Vue.use(Buefy)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
